export default __webpack_public_path__ + "static/media/NobelWGL-Bold.715a69a7.woff";